let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5nAfx")).then(() => parcelRequire('3y8Hw'));